/**
 * @file Domain types for messages the user sees in the chat, plus the "step"
 * variant that appears inline during tool execution, and the canonical factory
 * that constructs them.
 */

export type StepStatus = 'pending' | 'done' | 'error'
export type ChatMessageSender = 'user' | 'assistant' | 'step'

export interface ChatMessage {
  id: string
  sender: ChatMessageSender
  text: string
  timestamp: Date
  stepStatus?: StepStatus
  skill?: string
}

export type StepMessage = ChatMessage & { sender: 'step'; stepStatus: StepStatus }

/**
 * Constructs a fresh `ChatMessage` stamped with the current time. When `skill`
 * is provided it is recorded on the message so the chat-history bubble can
 * render the skill chip alongside the text.
 */
export function buildMessage(
  id: string,
  sender: ChatMessageSender,
  text: string,
  skill?: string
): ChatMessage {
  return { id, sender, text, timestamp: new Date(), ...(skill ? { skill } : {}) }
}
